module.exports = __webpack_public_path__ + "img/task-9-g.8a2c5d21.png";